import React from "react"
import PropTypes from "prop-types"
import { MultiSelect } from "react-multi-select-component"
import { StyledDiv, Token, Item, ClearSelected } from "./styles"
import Checkboxes from "../checkboxes"

const MultiSelectField = ({ handleInputChange, simpleForm, ...rest }) => {
  const { options, value, multiSelect, name, invalid } = rest
  const maxValueLength = 150

  const onChange = (value) => {
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  const ValueRenderer = (selected, _options) => {
    if (selected.length) {
      const textLength = selected.map(({ label }) => label).join(", ").length
      if (textLength > maxValueLength) {
        return <span className="text">{`${selected.length} Items Selected`}</span>
      } else {
        return selected.map(({ label }) => <Token>{label}</Token>)
      }
    } else {
      return <span className="text">No Items Selected</span>
    }
  }

  const SimpleFormItemRenderer = ({ checked, option, onClick, disabled }) => (
    <Item className={`item-renderer ${disabled ? "disabled" : ""}`}>
      <Checkboxes
        name={option.value}
        value={checked ? option.value : 0}
        options={[[option.value, option.label]]}
        handleInputChange={onClick}
        multiple={false}
        disabled={disabled}
        simpleForm
        marginless
      />
    </Item>
  )

  const multiSelectProps = {
    options: options,
    value: value || [],
    onChange: multiSelect ? onChange : handleInputChange,
    labelledBy: "Select",
    className: `${value && value.length && "items"} ${invalid && "invalid"}`,
    name: name
  }
  multiSelectProps["valueRenderer"] = ValueRenderer
  if (simpleForm) {
    multiSelectProps["ItemRenderer"] = SimpleFormItemRenderer
    multiSelectProps["ClearSelectedIcon"] = <ClearSelected>Clear</ClearSelected>
  }

  return (
    <StyledDiv simpleForm={simpleForm}>
      <MultiSelect {...multiSelectProps} />
    </StyledDiv>
  )
}

MultiSelectField.propTypes = {
  name: PropTypes.string,
  handleInputChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  blank: PropTypes.string,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool,
  multiSelect: PropTypes.bool
}

MultiSelectField.defaultProps = {
  name: "",
  handleInputChange: () => {},
  options: [],
  blank: "",
  showValidation: false,
  invalid: false,
  multiSelect: false
}

export default MultiSelectField
